import { FC } from "react";

interface SkipTimeDistanceRecalcCalloutProps {
  isSkipSelected: boolean;
  testId?: string;
}

/** Appended to a termination run's confirmation banner when Skip is selected on the Distance Measurement control. */
export const SkipTimeDistanceRecalcCallout: FC<SkipTimeDistanceRecalcCalloutProps> = ({ isSkipSelected, testId }) =>
  isSkipSelected
    ? <p data-testid={testId} className="mb-0">Because Skip is selected, average and maximum time and distance will not be recalculated for this run and will not appear in the results — you&apos;ll still see gap and access changes.</p>
    : null;